import React from "react";
import { Box, Container } from "@mui/material";
import { motion } from "framer-motion";

import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import CustomText from "../../customComponents/customText";
import { Colors } from "../../assets/colors";
import AiDestination from "../../assets/images/aiDestination.svg";
import MainHeader from "../../customComponents/MainHeader.jsx";
let staticText = translation[language];

function Destination() {
  const customImageWidth = {
    xs: "100%", // mobile
    sm: 500, // tablet
    md: 600, // small desktop
    lg: 700, // large desktop
  };

  return (
    <Box sx={styles.appBarStyle}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Box sx={styles.contentWrapper}>
          <MainHeader
            heading={staticText.andaihubDest}
            headerStyle={styles.mainHeader}
          />
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <CustomText
              desc={
                "AndAIHub is a cutting-edge AI marketplace that connects businesses with the best AI plugins and solutions tailored to their specific needs. We cater our services to Startups, MSMEs, and Enterprises by understanding their unique business domains and recommending optimal AI integrations. Our platform showcases a curated selection of third-party AI products and services, alongside our own in-house developed plugins, agents, workflow and solutions. At AndAIHub, we pride ourselves on delivering customized AI solutions for every use case, ensuring our clients harness the full potential of AI to drive innovation and growth in their respective industries."
              }
              fontFamily="Inter"
              colorvalue={Colors.getAiReadyTxt}
              style={styles.getAiReadyTxt}
              h3
              fontWeight={400}
            />

            <Box sx={styles.boxImage}>
              
               <Box
                        component="img"
                        src={AiDestination}
                        alt={`index`}
                        sx={{
                          width: customImageWidth,
                          objectFit: "cover",
                          marginTop: { xs: 3, sm: 4, md: 5, lg: 6 }
                        }}
                      />
            </Box>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}

export default Destination;

const styles = {
  boxImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    width: "100%",
    marginTop: { xs: 2, sm: 3 },
  },
  image: {},
  mainHeader: {
    width: "100%",
    textAlign: "center",
    overflowWrap: "break-word",
    wordWrap: "break-word",
    padding: { xs: "0 16px", sm: "0 24px" },
    whiteSpace: "normal",
    margin: "0 auto",
    fontSize: { xs: "1.8rem", sm: "1.3rem", md: "2.8rem", lg: "3.5rem", xl: "3.5rem" },
  },
  getAiReadyTxt: {
    paddingBottom: { xs: 2, sm: 4 },
    marginTop: { xs: 2, sm: 3 },
    lineHeight: 1.5,
    paddingLeft: { xs: 2, sm: 8, md: 18 },
    paddingRight: { xs: 2, sm: 8, md: 18 },
    textAlign: "center",
    fontStyle: "initial",
    fontSize: { xs: "1rem", sm: "1.3rem", md: "inherit" },
  },
  andaihubTxt: {
    textAlign: "center",
    lineHeight: 1.5,
    letterSpacing: "-0.01em",
    fontStyle: "initial",
  },

  appBarStyle: {
    overflowX: "hidden",
    boxSizing: "border-box",
    backgroundColor: Colors.themeColor,
    paddingLeft: { xs: "5vw", sm: "8vw", md: "13vw" },
    paddingRight: { xs: "5vw", sm: "8vw", md: "13vw" },
  },

  containerStyle: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
    paddingTop: { xs: 6, sm: 8, md: 13 },
    paddingBottom: { xs: 8, sm: 15, md: 20 },
  },
  contentWrapper: {
    width: "100%",
    maxWidth: { xs: "100%", sm: "100%", md: "100%" },
    margin: "0 auto",
    overflow: "hidden",
  },
};
